module.exports = __webpack_public_path__ + "static/5-294322cb537616bd27e45294d74ac382.png";